"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var colors_1 = require("../colors");
var Logout = function (_a) {
    var type = _a.type, width = _a.width, height = _a.height, fill = _a.fill;
    switch (type) {
        case 'line':
        default:
            return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 40 40", fill: "none" },
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.8182 4.54547H18.1818L18.1818 7.38527V11.06L18.1818 23.6364C20.1901 23.6364 21.8182 22.0083 21.8182 20V11.06V7.38527V4.54547ZM5.45456 21.8182C5.45456 15.7138 9.21477 10.4879 14.5455 8.3301V12.3686C11.2846 14.2549 9.09092 17.7803 9.09092 21.8182C9.09092 27.8431 13.9751 32.7273 20 32.7273C26.025 32.7273 30.9091 27.8431 30.9091 21.8182C30.9091 17.7803 28.7154 14.2549 25.4546 12.3686V8.3301C30.7853 10.4879 34.5455 15.7138 34.5455 21.8182C34.5455 29.8515 28.0333 36.3637 20 36.3637C11.9667 36.3637 5.45456 29.8515 5.45456 21.8182Z", fill: fill })));
    }
};
Logout.propTypes = {
    type: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fill: PropTypes.string,
};
Logout.defaultProps = {
    type: 'solid',
    width: 40,
    height: 40,
    fill: colors_1.grey5,
};
exports.default = Logout;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9nb3V0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ljb25zL0xvZ291dC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw2QkFBK0I7QUFDL0Isc0NBQXdDO0FBRXhDLG9DQUFnQztBQVFoQyxJQUFNLE1BQU0sR0FBMEIsVUFBQyxFQUEyQjtRQUExQixjQUFJLEVBQUUsZ0JBQUssRUFBRSxrQkFBTSxFQUFFLGNBQUk7SUFDL0QsUUFBUSxJQUFJLEVBQUU7UUFDWixLQUFLLE1BQU0sQ0FBQztRQUNaO1lBQ0UsT0FBTyxDQUNMLDZCQUFLLEtBQUssRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUMsV0FBVyxFQUFDLElBQUksRUFBQyxNQUFNO2dCQUNoRSw4QkFDRSxRQUFRLEVBQUMsU0FBUyxFQUNsQixRQUFRLEVBQUMsU0FBUyxFQUNsQixDQUFDLEVBQUMsc2hCQUFzaEIsRUFDeGhCLElBQUksRUFBRSxJQUFJLEdBQ1YsQ0FDRSxDQUNQLENBQUM7S0FDTDtBQUNILENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxTQUFTLEdBQUc7SUFDakIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxNQUFhO0lBQzdCLEtBQUssRUFBRSxTQUFTLENBQUMsU0FBUyxDQUFDLENBQUMsU0FBUyxDQUFDLE1BQU0sRUFBRSxTQUFTLENBQUMsTUFBTSxDQUFDLENBQVE7SUFDdkUsTUFBTSxFQUFFLFNBQVMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxTQUFTLENBQUMsTUFBTSxFQUFFLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBUTtJQUN4RSxJQUFJLEVBQUUsU0FBUyxDQUFDLE1BQU07Q0FDdkIsQ0FBQztBQUVGLE1BQU0sQ0FBQyxZQUFZLEdBQUc7SUFDcEIsSUFBSSxFQUFFLE9BQU87SUFDYixLQUFLLEVBQUUsRUFBRTtJQUNULE1BQU0sRUFBRSxFQUFFO0lBQ1YsSUFBSSxFQUFFLGNBQUs7Q0FDWixDQUFDO0FBRUYsa0JBQWUsTUFBTSxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@riiid/santa-closet-web/icons/Logout.js
// module id = 78
// module chunks = 0